import { atom } from "recoil";
import { ObjectiveKey, ObjectivePresetId } from "shared/domain/objectivePresets";

// CFDの実行結果
export interface CFDStatus {
  status_code: number;
  name: string;
  presetId: ObjectivePresetId;
  objectives: ObjectiveKey[];
  cfd_id: Record<ObjectiveKey, string>;
  value: Record<ObjectiveKey, number>;
  status: Record<ObjectiveKey, string>;
  // study 単位で 1 個。成功 / 進行中は null。後方互換のため optional
  error_code?: string | null;
}

// 過去CFD 一覧
export const CFDHistoryState = atom<string[]>({
  key: "CFDHistoryState",
  default: [],
});

// 過去CFD ロード
export const CFDHistoryLoadingState = atom<boolean>({
  key: "CFDHistoryLoadingState",
  default: false,
});

// ユーザがCFDタブのドロップダウンで選択した単発CFD
export const selectedCFDState = atom<CFDStatus | null>({
  key: "selectedCFDState",
  default: null,
});

// 結果を描画するCFD
export const displayCFDState = atom<CFDStatus | null>({
  key: "displayCFDState",
  default: null,
});

// cfd idに対応するtask arn
export const taskArnMapState = atom<Record<string, string>>({
  key: "taskArnMapState",
  default: {},
});
